import { render, staticRenderFns } from "./MatchInfo.vue?vue&type=template&id=cd58ac16&scoped=true"
import script from "./MatchInfo.vue?vue&type=script&lang=js"
export * from "./MatchInfo.vue?vue&type=script&lang=js"
import style0 from "./MatchInfo.vue?vue&type=style&index=0&id=cd58ac16&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "cd58ac16",
  null
  
)

export default component.exports